<template>
  <div id="doorManage">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
              <el-form-item :label="$t('task.system')" >
                <el-select v-model="filterForm.systemType" :placeholder="$t('task.chooseSystem')">
                  <el-option
                    v-for="item in systemOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.region')" >
                <el-select v-model="filterForm.regionNo" multiple :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in regionOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.province')" >
                <el-select v-model="filterForm.provinceNo" multiple :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.city')" >
                <el-select v-model="filterForm.cityNo" multiple :placeholder="$t('filters.chooseCity')" @visible-change="getRangeList()">
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="Cluster Name" >
                <el-select v-model="filterForm.clusterName" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in clusterNameOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="门店类型" >
                <el-select v-model="filterForm.concept" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in conceptOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="City Tier" >
                <el-select v-model="filterForm.clusterGroup" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in cityTierOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Tz Group" >
                <el-select v-model="filterForm.tzGroup" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in tzGroupOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Format" >
                <el-select v-model="filterForm.format" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in formatOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item :label="$t('filters.reseller')" >
                <el-select v-model="filterForm.resellerNo" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in resellerOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.subReseller')" >
                <el-select v-model="filterForm.subReseller" multiple :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in subResellerOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="HubDoor" >
                <el-select v-model="filterForm.hubDoor" clearable :placeholder="$t('choose')" @change="resetFilters()">
                  <el-option
                    v-for="item in hubDoorOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item :label="$t('filters.doorName')" >
                <span @click="onChooseDoor">
                  <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
                </span>
              </el-form-item>
              <el-form-item label="门店编号">
                <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="20">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onExport">{{ $t('export') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="filterBtns filterBtnsRight">
                  <input type="file" ref="importData" @change="importData" id="importFileInput">
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                prop="doorName"
                :label="$t('filters.doorName')"
              >
              </el-table-column>
              <el-table-column
                prop="posId"
                label="门店编号"
              >
              </el-table-column>
              <el-table-column
                prop="systemType"
                :label="$t('task.system')"
              >
              </el-table-column>
              <el-table-column
                prop="regionName"
                :label="$t('filters.region')"
              >
              </el-table-column>
              <el-table-column
                prop="provinceName"
                :label="$t('filters.province')"
              >
              </el-table-column>
              <el-table-column
                prop="cityName"
                :label="$t('filters.city')"
              >
              </el-table-column>
              <el-table-column
                prop="resellerName"
                :label="$t('filters.reseller')">
              </el-table-column>
              <el-table-column
                prop="concept"
                label="门店类型"
              >
              </el-table-column>
              <el-table-column :label="$t('operation')">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openDetail(scope.row)">{{ $t('see') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
    <el-dialog
      :title="$t('setting.doorDetail')"
      :visible.sync="detailDialogVisible"
      width="36%"
      center
    >
      <div>
        <el-descriptions :column="1" title="">
          <el-descriptions-item :label="$t('filters.doorName')">{{ detailForm.doorName }}</el-descriptions-item>
          <el-descriptions-item label="门店编号">{{ detailForm.posId }}</el-descriptions-item>
          <el-descriptions-item :label="$t('filters.region')">{{ detailForm.regionName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('filters.province')">{{ detailForm.provinceName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('filters.city')">{{ detailForm.cityName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('filters.reseller')">{{ detailForm.resellerName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('filters.subReseller')">{{ detailForm.subReseller }}</el-descriptions-item>
          <!-- <el-descriptions-item label="ClusterName">{{ detailForm.clusterName }}</el-descriptions-item>
          <el-descriptions-item label="ClusterGroup">{{ detailForm.clusterGroup }}</el-descriptions-item>
          <el-descriptions-item label="TZGroup">{{ detailForm.tzGroup }}</el-descriptions-item>
          <el-descriptions-item label="Format">{{ detailForm.format }}</el-descriptions-item> -->
          <el-descriptions-item label="门店类型">{{ detailForm.concept }}</el-descriptions-item>
          <!-- <el-descriptions-item label="HubDoor">{{ detailForm.hubDoor ? '是' : '否' }}</el-descriptions-item> -->
          <el-descriptions-item :label="$t('task.system')">{{ detailForm.systemType }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import PickDoor from "../../components/pickDoor";
export default {
  name: 'DoorLog',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      detailDialogVisible: false,
      systemOptions: [
      ],
      filterForm: {
      },
      initDetailForm: {
        doorName: '', // 门店名称
        posId: '', // posid
        regionName: '', // 区域
        provinceName: '', // 省份
        cityName: '', // 城市
        resellerName: '', // 客户
        subReseller: '', //二级客户
        clusterName : '', //clusterName
        clusterGroup : '', //clusterGroup
        tzGroup : '', //clusterGroup
        format: '', //format
        concept: '', // concept
        hubDoor: '', // hub
        systemType: '', // 系统
      },
      detailForm: {
      }, // 门店详情内容
      initFilterForm: {
        regionNo: '',
        provinceNo: '',
        cityNo: '',
        clusterName: '',
        concept: '',
        clusterGroup: '',
        tzGroup: '',
        format: '',
        resellerNo: '',
        subReseller: '',
        hubDoor: '',
        doorName: '',
        posId: '',
        systemType: ''
      },
      filterRegionOptions: [],
      roleOptions: [],
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      regionOptions: [
      ],
      provinceOptions: [
      ],
      cityOptions: [
      ],
      clusterNameOptions: [
      ],
      conceptOptions: [
      ],
      cityTierOptions: [
      ],
      tzGroupOptions: [
      ],
      formatOptions: [
      ],
      resellerOptions: [
      ],
      subResellerOptions: [
      ],
      hubDoorOptions: [
      ]
    }
  },
  mounted () {
    this.getSystemOptions()
    this.getRangeList()
    this.onReset()
  },

  methods: {
    getSystemOptions: async function () {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        this.systemOptions = _.map(res.data, (system) => ({
          itemKey: system.code,
          itemValue: system.desc,
        }))
      }
    },
    openDetail: async function(row) {
      this.detailDialogVisible = true
      this.detailForm = _.cloneDeep(this.initDetailForm)
      let res = await window.instance.post(window.retailinkUrl + '/door/getDoor/' + row.id)
      res = res.data
      if (res.code === 200) {
        this.detailForm = _.cloneDeep(res.data)
      }
    },

    onExport: async function() {
      const submitData = this.$tool.formatArrayToString(this.filterForm)
      submitData.current = this.tableConfig.current
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: window.retailinkUrl + "/door/doorExport",
        data: submitData
      });
    },
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },

    resetFilters: function () {
      this.getRangeList()
    },
    importData: async function ({ target }) {
      let formData = new FormData()
      formData.append('file', target.files[0])
      let res = await window.instance.post(window.surveyUrl + '/door/import', formData)
      document.getElementById('importFileInput').value = ''
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
      }
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNo': this.filterForm.cityNo,
        'clusterGroup': this.filterForm.clusterGroup,
        'clusterName': this.filterForm.clusterName,
        'concept': this.filterForm.concept,
        'resellerNo': this.filterForm.resellerNo,
        'subReseller': this.filterForm.subReseller,
        'format': this.filterForm.format,
        'provinceNo': this.filterForm.provinceNo,
        'regionNo': this.filterForm.regionNo,
        'tzGroup': this.filterForm.tzGroup,
        'hubDoor': this.filterForm.hubDoor
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailinkUrl + '/door/queryConditions', submitParams)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = res.regionList
      this.provinceOptions = res.provinceList
      this.cityOptions = res.cityList
      this.cityTierOptions = res.clusterGroupList
      this.clusterNameOptions = res.clusterNameList
      this.conceptOptions = res.conceptList
      this.formatOptions = res.formatList
      this.resellerOptions = res.resellerList
      this.subResellerOptions = res.subResellerList
      this.tzGroupOptions = res.tzGroupList
      this.hubDoorOptions = res.hubDoorList
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let submitParams = this.$tool.formatArrayToString(this.filterForm)
      let res = await window.instance.post(window.retailinkUrl + '/door/listDoor', _.assign(submitParams, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },

    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
      this.resetFilters()
    },
  }
}
</script>

<style scoped lang="sass">
#doorManage
  .roleName
    color: #ff6801
    margin-left: 32px
    margin-bottom: 20px
  .roleCode
    margin-left: 32px
    margin-bottom: 14px
    label
      padding: 5px 0
  .tabs
    margin: 0 0 0 30px
  input[type=file]
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/setting/doorManage.vue